/**
 * Phase 6 — Keyboard hint
 *
 * The little "⌘K" pills you see all over Linear's command menu.
 */

import * as React from "react";
import { cn } from "@/lib/utils";

export const RdKbd = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, children, ...props }, ref) => (
  <kbd
    ref={ref as React.Ref<HTMLElement>}
    className={cn(
      "inline-flex items-center justify-center min-w-[20px] h-[20px] px-1.5",
      "rounded-[4px] border border-[hsl(var(--rd-border))]",
      "bg-[hsl(var(--rd-surface-2))] text-[hsl(var(--rd-text-muted))]",
      "font-mono text-[10.5px] font-medium",
      "shadow-[0_1px_0_0_hsl(var(--rd-border))]",
      className
    )}
    {...props}
  >
    {children}
  </kbd>
));
RdKbd.displayName = "RdKbd";
